import { DropdownMenuContext } from '@tmh-website/shared';
import { Color } from '@tmh-website/shared/colors';
import ButtonUiText from '@tmh-website/ui/ButtonUiText';
import { useContext } from 'react';
import { useActiveModifiers } from 'react-day-picker';
import { useTranslation } from 'react-i18next';
import { calendarThemes } from './Calendar.theme';
import * as Styled from './CalendarFooter.styles';
import { useCalendar } from './calendar.service';

interface FooterProps {
  /**
   * The month where the footer is displayed.
   */
  displayMonth?: Date;
}

const CalendarFooter: (props: FooterProps) => JSX.Element = () => {
  const { t } = useTranslation();
  const { onSelect, value, themeColor } = useCalendar();
  const activeModifiers = useActiveModifiers(value as Date);
  const { forceClose } = useContext(DropdownMenuContext);

  return (
    <Styled.Container>
      <tr>
        <td colSpan={7}>
          <Styled.ButtonContainer>
            <ButtonUiText
              themeColor={calendarThemes[themeColor].footerButtonsThemeColor}
              onClick={e => onSelect?.(undefined, value as Date, activeModifiers, e)}
              fullWidth
              isSmall>
              {t('global:clear')}
            </ButtonUiText>

            <ButtonUiText themeColor={Color.Blue_500_Ultramarine} onClick={() => forceClose()} fullWidth isSmall>
              {t('global:save')}
            </ButtonUiText>
          </Styled.ButtonContainer>
        </td>
      </tr>
    </Styled.Container>
  );
};

export default CalendarFooter;
